<template>
  <!--begin::Advance Table Widget 2-->
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          List Roles
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          The total number of roles right now : {{ role_data.length }}
        </span>
      </h3>
      <div class="card-toolbar">
        <ul class="nav nav-pills nav-pills-sm nav-dark-75">
          <li class="nav-item mx-2">
            <b-button v-b-modal.modal-add-role variant="info">create role</b-button>

            <b-modal
                id="modal-add-role"
                title="Add New Role"
                ref="modal-add-role"
                hide-footer
                centered
                size="md"
            >
              <b-form @submit.prevent="submitFormAddRole" @reset="onResetFormAddRole" novalidate>
                <b-form-group
                    label="Role Name:"
                    label-for="input-role-name"
                    description="Enter the role name."
                >
                  <b-form-input
                      id="input-role-name"
                      v-model.trim="form_add_role.name"
                      required
                      placeholder="Enter role name"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Team Name:"
                    label-for="input-team-name"
                    description="Specify the associated team."
                >
                  <b-form-input
                      id="input-team-name"
                      v-model.trim="form_add_role.team_name"
                      required
                      placeholder="Enter team name"
                  ></b-form-input>
                </b-form-group>

                <!-- Buttons in one row -->
                <div class="d-flex justify-content-between mt-4">
                  <b-button type="reset" variant="outline-secondary">
                    Reset
                  </b-button>
                  <b-button type="submit" variant="primary">
                    Create Role
                  </b-button>
                  <b-button variant="outline-danger" @click="hideModal">
                    Close
                  </b-button>
                </div>
              </b-form>
            </b-modal>

          </li>
          <li class="nav-item mx-2">
            <b-button variant="primary" @click="getRoles" ref="kt_list_update_users">Update</b-button>
          </li>

        </ul>
      </div>
    </div>

    <div class="card-body pt-3 pb-0">
      <b-modal
          id="modal-edit-role"
          :title="`Edit Role: ${form_edit_role.id}`"
          ref="modal-edit-role"
          hide-footer
          centered
          size="xl"
      >
        <b-form @submit.prevent="submitFormEditRole" novalidate>
          <b-form-group label="Select Permissions for This Role:">
            <table class="table table-bordered table-sm border border-3">
              <tbody>
              <tr v-for="(rowGroups, rowIndex) in chunkedGroups" :key="rowIndex">
                <td
                    v-for="(groupName, colIndex) in rowGroups"
                    :key="colIndex"
                    class="align-top border border-3"
                    style="width: 14%;"
                >
                  <div class="fw-bold text-capitalize border-bottom pb-1 mb-2">
                    {{ groupName }}
                  </div>
                  <b-form-checkbox-group v-model="form_edit_role.permissions">
                    <b-form-checkbox
                        v-for="perm in groupPermissions(permission)[groupName]"
                        :key="perm.id"
                        :value="perm.id"
                        class="d-block mb-1"
                    >
                      {{ perm.name.split('.').slice(1).join('.') || perm.name }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </td>
              </tr>
              </tbody>
            </table>
          </b-form-group>

          <div class="d-flex justify-content-between mt-4">
            <b-button variant="outline-danger" @click="hideModal">Close</b-button>
            <b-button type="submit" variant="primary">Save Changes</b-button>
          </div>
        </b-form>
      </b-modal>


      <!--begin::Table-->
      <div class="table-responsive">
        <table class="table table-hover table-bordered text-center align-middle">
          <thead class="thead-dark">
          <tr>
            <th class="fw-bold" style="width: 50px;">#</th>
            <th class="fw-bold">Name</th>
            <th class="fw-bold">Team</th>
            <th class="fw-bold">Permissions</th>
            <th class="fw-bold">Actions</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(item, i) in role_data">
            <tr :key="i">
              <td>{{ i + 1 }}</td>
              <td class="fw-semibold text-dark  text-center align-middle">{{ item.name }}</td>
              <td>
          <span class="text-dark fw-semibold">
            {{ item.team_name ?? '-' }}
          </span>
              </td>
              <td class="text-start">
                <div v-if="item.permissions.length">
                  <div v-for="(group, groupName) in groupPermissions(item.permissions)" :key="groupName" class="mb-2">
                    <details>
                      <summary class="fw-bold text-capitalize text-secondary">
                        {{ groupName }}
                      </summary>
                      <div class="mt-2">
                  <span
                      v-for="perm in group"
                      :key="perm.id"
                      class="badge bg-warning mr-1 mb-1 text-black"
                  >
                    {{ perm.name.split('.').slice(1).join('.') || perm.name }}
                  </span>
                      </div>
                    </details>
                  </div>
                </div>
                <span v-else class="badge bg-danger">No Access</span>
              </td>
              <td class=" text-center align-middle">
          <span
              class="mr-2"
              style="cursor: pointer;"
              v-b-tooltip.hover
              title="Edit Role"
              @click="showModalEditRole(item.id, item.name)"
          >
            <inline-svg src="media/svg/icons/Communication/Write.svg"></inline-svg>
          </span>
                <span
                    class="mr-2"
                    style="cursor: pointer;"
                    v-b-tooltip.hover
                    title="Delete Role"
                    @click="deleteRoles(item.id, item.name)"
                >
            <inline-svg src="media/svg/icons/General/Trash.svg"></inline-svg>
          </span>
              </td>
            </tr>
          </template>
          </tbody>
        </table>

      </div>
      <!--end::Table-->
    </div>
    <!--end::Body-->
    <!--end::Advance Table Widget 2-->
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {ADD_USERS, LIST_USERS} from "@/core/services/store/users.module";
import {ADD_ROLE, DELETE_ROLE, EDIT_ROLE, LIST_ROLES} from "@/core/services/store/roles.module";
import {ADD_PERMISSIONS, DELETE_PERMISSIONS, LIST_PERMISSIONS} from "@/core/services/store/permissions.module";
import Swal from "sweetalert2";

export default {
  name: "table-roles",
  data() {
    return {
      data: [],
      permission: [],
      role_data: [],
      form_add_role: {
        name: '',
        team_name: '',
      },
      form_change_pass: {
        username: "",
        new_password: "",
        new_password_confirmation: ""
      },
      form_edit_role: {
        id: null,
        name: "",
        team_name: "",
        permissions: []
      }
    };
  },
  components: {},
  methods: {
    groupPermissions(permissions) {
      const grouped = {};
      permissions.forEach((perm) => {
        const [prefix] = perm.name.split('.');
        if (!grouped[prefix]) grouped[prefix] = [];
        grouped[prefix].push(perm);
      });
      return grouped;
    },
    getPermission() {
      this.$store.dispatch(LIST_PERMISSIONS).then((res) => {
        this.permission = res
      }).catch(() => {
      });
    },
    getRoles() {
      const submitButton = this.$refs["kt_list_update_users"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store.dispatch(LIST_ROLES)
          .then((res) => {
            this.role_data = res
            submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
            );
          })
          .catch((error) => {
            console.error("Error:", error);
          });
    },
    deleteRoles(id, name) {
      Swal.fire({
        title: `Are you sure you want to delete the Role ${name}?`,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "YES",
        denyButtonText: `NO`
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch(DELETE_ROLE, {id: id}).then((res) => {
            Swal.fire({
              icon: "success",
              title: `Role ${name} Deleted`
            });
            this.getRoles()
          });
        } else if (result.cancel) {
          Swal.fire("Not Deleted", "", "info");
        }
      });
    },
    changeActiveStatus(i, username, status) {
      this.data[i].is_active = !status
      let sender = {
        username: username,
        new_status: !status
      }
    },
    submitFormAddRole() {
      if (this.form_add_role.name == "" || this.form_add_role.team_name == "") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "please input all data",
        });
      } else {
        this.$store.dispatch(ADD_ROLE, this.form_add_role).then((res) => {
          this.getRoles()
          this.$refs['modal-add-role'].hide();
          Swal.fire({
            icon: "success",
            title: "Role Added"
          });
        });
      }
    },
    submitFormChangePass(evt) {
      evt.preventDefault()
      alert(JSON.stringify(this.form_change_pass))
    },
    submitFormEditRole() {
      this.$store.dispatch(EDIT_ROLE, this.form_edit_role).then((res) => {
          this.getRoles();
          this.$refs['modal-edit-role'].hide();
          Swal.fire({
            icon: "success",
            title: "Role Changed"
          });
        }).catch((err) => {
          console.error(err);
        });
    },
    onResetFormAddRole(evt) {
      evt.preventDefault()
      this.form_add_role.name = ''
      this.form_add_role.team_name = ''
    },
    hideModal() {
      this.$refs['modal-edit-role'].hide()
    },
    showModalEditRole(id, name) {
      this.form_edit_role.id = id
      this.form_edit_role.name = name
      const roleInfo = this.role_data.find(role => role.id === id);
      this.form_edit_role.permissions = roleInfo.permissions.map(item => item.id);
      this.$refs['modal-edit-role'].show()
    }
  },
  computed: {
    chunkedGroups() {
      const groups = Object.keys(this.groupPermissions(this.permission));
      const chunkSize = 6;
      const chunks = [];
      for (let i = 0; i < groups.length; i += chunkSize) {
        chunks.push(groups.slice(i, i + chunkSize));
      }
      return chunks;
    },
    ...mapGetters(["layoutConfig"]),
  },
  mounted() {
    this.getRoles()
    this.getPermission()
  }
};
</script>
